import { render, staticRenderFns } from "./ProjectTarget.vue?vue&type=template&id=49afee60&scoped=true"
import script from "./ProjectTarget.vue?vue&type=script&lang=js"
export * from "./ProjectTarget.vue?vue&type=script&lang=js"
import style0 from "./ProjectTarget.vue?vue&type=style&index=0&id=49afee60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afee60",
  null
  
)

export default component.exports